export default __webpack_public_path__ + "static/media/egg5.db303608.jpg";